export default __webpack_public_path__ + "static/media/btn_moreinfo_az.9ef82132.png";